module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-up-big/wow-fade-in-up-big.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-up-big/wow-fade-in-up-big.component.scss
// module chunks = main